export const sendEvent = (eventData: any): void => {
  try {
    (window as any).dataLayer.push(eventData);
  } catch (err) {
    /* noop */
  }
};
